export default __webpack_public_path__ + "static/media/contact-full-HD.26b0eb0b.jpg";